import { useContext } from 'react';
import { Routes, Route } from 'react-router-dom';
import { AppUserContext } from '../../App';
import { ErrorLoading } from '../../components/loading';
import NewPayment from './allowancemanipulation';
import ViewPayments from './view-allowances';
import PaymentDetails from './view-details';

const Allowances = () => {

    const { profile } = useContext(AppUserContext);

    if (profile.permission_level > 2) {
        return <ErrorLoading>You do not have the permission to access the staff payments.</ErrorLoading>
    }

    return (
        <Routes>
            <Route path="new" element={<NewPayment />} />
            <Route path=":allowanceid/*" element={<PaymentDetails />} />
            <Route path="/" element={<ViewPayments />} />
        </Routes>
    )
};

export default Allowances;